import apiClient from '../utils/apiClient';

const base = (facilityId) => `/api/facilities/${facilityId}/leads`;

const leadsService = {
  getAll: (facilityId) => apiClient.get(`${base(facilityId)}/`),
  create: (facilityId, data) => apiClient.post(`${base(facilityId)}/`, data),
  update: (facilityId, id, data) => apiClient.put(`${base(facilityId)}/${id}`, data),
  convert: (facilityId, id, data) => apiClient.post(`${base(facilityId)}/${id}/convert`, data),
  remove: (facilityId, id) => apiClient.delete(`${base(facilityId)}/${id}`),
};

export default leadsService;
